import { ImagePlaceholder } from "./ImagePlaceholder";

export const PersonCard = ({ person }) => (
  <div data-testid={`person-card-${person.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
    {person.photo ? (
      <img
        src={person.photo}
        alt={`Portrait of ${person.name}`}
        loading="lazy"
        data-testid={`person-photo-${person.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        className="w-full object-cover object-top block mb-4"
        style={{ aspectRatio: "1 / 1", background: "var(--navy-100)" }}
      />
    ) : (
      <ImagePlaceholder
        file={`portrait-${person.name.split(" ")[0].toLowerCase().replace(/[^a-z]/g, "")}.jpg`}
        ratio="1 / 1"
        label={`Portrait of ${person.name}`}
        className="mb-4"
      />
    )}
    <h4 className="text-h4 mb-1">{person.name}</h4>
    <p className="body-sm m-0 mb-1" style={{ color: "var(--navy-500)" }}>
      {person.role}
    </p>
    <p className="caption m-0">{person.thesis}</p>
  </div>
);
